<template>
  <div class="scorecard">
    <div class="grid-row">
      <h3>Score card</h3> <div v-if="totalCategories" class="awardsGiven">{{ awardsPresented }} of {{ totalCategories }} awards presented.</div>
    </div>
    <ul v-if="currentYear">
      <li><div>Voter</div><div class="text-center">Score</div><div class="text-center">Best Possible</div></li>
      <li v-for="voter in voters" :key="voter['.key']"><div>{{ voter.displayName }}</div><div class="text-center">{{ voter.correctVotes }}</div><div class="text-center">{{ totalCategories - awardsPresented +  voter.correctVotes }}</div></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Scorecard',
  props: ['currentYear'],
  computed: {
    voters() {
      let voters = [];
      if (this.currentYear) {
        let votes = this.currentYear.year.votes;

        for (let voter in votes) {
                    console.log(votes[voter].displayName);
          let thisVoter = {
            '.key': voter,
            displayName: votes[voter].displayName,
            correctVotes: 0
          };
          for (let category in this.currentYear.year.categories) {
            for (let nominee in this.currentYear.year.categories[category].nominees) {
              ;
              if (this.currentYear.year.categories[category].nominees[nominee].winner) {
                if (nominee == votes[voter][category]) {
                  thisVoter.correctVotes++;
                }
              }
            }
          }
          voters.push(thisVoter);
        }
      };

      let sortedVoters = [...voters].sort((one, two) => { return one.correctVotes + two.correctVotes; });

      return sortedVoters;
    },
    totalCategories() {
      let totalCategories = null;

      if (this.currentYear) {
        totalCategories = Object.keys(this.currentYear.year.categories).length;
      };

      return totalCategories;
    },
    awardsPresented() {
      let awardsPresented = 0;

      for (let category in this.currentYear.year.categories) {
        for (let nominee in this.currentYear.year.categories[category].nominees) {
          ;
          if (this.currentYear.year.categories[category].nominees[nominee].winner) {
            awardsPresented++;
          }
        }
      }

      return awardsPresented;
    }
  }
};
</script>

<style lang="scss">
  @import '../sass/_config';

  .scorecard {
    margin: 35px 0;

    .grid-row {
      display: grid;
      grid-template-columns: 50% 50%;
    }
    .awardsGiven {
      align-self: center;
      text-align: right;
    }

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;

      li {
        border-bottom: 1px solid $border;
        display: grid;
        grid-template-columns: 50% 25% 25%;
        padding: 10px 0;
      }

      li:first-child {
        font-weight: bold;
      }
    }
  }
</style>
